let nav = {
    $menuToggle: $('#js-navMenuToggle'),
    classNameMenuActive: 'is-menu',

    init() {
        this.$menuToggle.on(Modernizr.touch ? 'touchstart' : 'click', (e) => {
            e.preventDefault()
            $('body').toggleClass(this.classNameMenuActive)
        })
    }
}

export default nav